import { Component, OnInit } from '@angular/core';
import { StaticDataService } from "../../../_services/generatedServices";
import { CaptivePortalAuthorizeRequest } from "../../../_models/generatedModels";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: 'bxl-captiveportal',
  templateUrl: 'captiveportal.component.html',
})
export class CaptiveportalComponent implements OnInit {
  initialized = false;
  submitComplete: Promise<any>;
  mac: string;
  model:CaptivePortalAuthorizeRequest;
  constructor(private staticData: StaticDataService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.model = new CaptivePortalAuthorizeRequest();
    this.route.queryParamMap.subscribe((params) => {
      this.model.mac = params.get('id');
      this.model.ap = params.get('ap');
      this.model.ssid = params.get('ssid');
      this.model.redirectUrl = params.get('url');
      console.log
      this.initialized = true;
    })
  }
  public processAuth() {
    this.submitComplete = new Promise((resetButton: any, reject) => {

      this.staticData.captivePortalAuthorize(this.model).subscribe(result => {
        if (this.model.redirectUrl && this.model.redirectUrl.length > 0) {
          window.location.href = this.model.redirectUrl;
        }else{
          window.location.href = '/';
        }
        resetButton();
      },()=>{
        resetButton();
      });
    });
  }
}
